// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../index.mjs";
export const ExampleQueryParameterShape = {
    single: () => {
        return {
            type: "single",
            _visit: function (visitor) {
                return FernIr.ExampleQueryParameterShape._visit(this, visitor);
            },
        };
    },
    exploded: () => {
        return {
            type: "exploded",
            _visit: function (visitor) {
                return FernIr.ExampleQueryParameterShape._visit(this, visitor);
            },
        };
    },
    commaSeparated: () => {
        return {
            type: "commaSeparated",
            _visit: function (visitor) {
                return FernIr.ExampleQueryParameterShape._visit(this, visitor);
            },
        };
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "single":
                return visitor.single();
            case "exploded":
                return visitor.exploded();
            case "commaSeparated":
                return visitor.commaSeparated();
            default:
                return visitor._other(value);
        }
    },
};
